import React, { useEffect, useState } from "react";
import axios from "axios";

const DroneSpaceMap = () => {
  const [accessToken, setAccessToken] = useState(null);
  async function fetchAccessToken() {
    const url = "https://outpost.mappls.com/api/security/oauth/token";
    // const params = new URLSearchParams();
    const body = {
      grant_type: "client_credentials",
      client_id:
        "96dHZVzsAutNEw5tQ1A1fC97fKPQZHMFbHBjUHcrHAbX_HDQ9RJMejxLMKYMEiv2jUMv7Qho4mHCdPDZMdL1-A==",
      client_secret:
        "lrFxI-iSEg9TGhmXrbagkW06jvT4RboYZKtsY60WyKQy-z2__QodzEC-8R7Rs35Eokx8Gq772cxgJ-J8EtKhaHjG-HB7rC7Z",
    };
    // params.append('grant_type', 'client_credentials');
    // params.append('client_id', '96dHZVzsAutNEw5tQ1A1fC97fKPQZHMFbHBjUHcrHAbX_HDQ9RJMejxLMKYMEiv2jUMv7Qho4mHCdPDZMdL1-A==');
    // params.append('client_secret', 'lrFxI-iSEg9TGhmXrbagkW06jvT4RboYZKtsY60WyKQy-z2__QodzEC-8R7Rs35Eokx8Gq772cxgJ-J8EtKhaHjG-HB7rC7Z');

    try {
      const response = await axios.post(url, body, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      });
      return response.data.access_token;
    } catch (error) {
      throw new Error("Failed to fetch access token");
    }
  }

  useEffect(() => {
    const fetchToken = async () => {
      try {
        const token = await fetchAccessToken();
        setAccessToken(token);
      } catch (error) {
        console.error("Error fetching access token:", error);
      }
    };

    fetchToken();
  }, []);

  useEffect(() => {
    if (!accessToken) return;

    const initMap = () => {
      const map = new window.mappls.Map("map", {
        center: [29.1492, 75.7217],
        zoom: 4,
      });
      window.mappls.airspaceLayer({
        key: accessToken,
        map: map,
        multiple: true,
      });

      new window.mappls.Marker({
        map: map,
        position: { lat: 29.1492, lng: 75.7217 },
        fitbounds: false,
        popupHtml: "<div>Hello World</div>",
      });
    };

    if (!window.mapScriptLoaded) {
      const script = document.createElement("script");
      script.src = `https://apis.mappls.com/advancedmaps/api/${accessToken}/map_sdk?layer=vector&v=3.0&airspacelayers&callback=initMap`;
      script.async = true;
      script.onload = () => {
        window.mapScriptLoaded = true;
        initMap();
      };
      document.head.appendChild(script);

      const pluginScript = document.createElement("script");
      pluginScript.src = `https://apis.mappls.com/advancedmaps/api/${accessToken}/map_sdk_plugins?v=3.0`;
      pluginScript.async = true;
      document.head.appendChild(pluginScript);
    } else {
      initMap();
    }

    return () => {
      // Clean up if necessary
    };
  }, [accessToken]);

  return (
    <div
      id="map"
      style={{ width: "100%", height: "100vh", margin: 0, padding: 0 }}
    ></div>
  );
};

export default DroneSpaceMap;
